<template>
    <div>
        <el-drawer title="订单退款" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
            size="450px" @close="close">
            <div class="drawer-content" v-loading="dataLoading">
                <el-form v-if="data" :model="formData" ref="formData" label-position="top">
                    <el-form-item prop="type">
                        <el-radio-group v-model="formData.type" size="medium">
                            <el-radio :label="1" border>待退款</el-radio>
                            <el-radio :label="2" border :disabled="disabledType2 == true">已退款</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <template v-if="formData.type == 1">
                        <div v-for="(item, index) in formData.orderRefundDetailTOS" :key="index" class="tips">
                            <div class="goodsItem">
                                {{ data[index].goodName }} <span class="color-info">{{ data[index].skuDesc }}</span>
                                <span v-if="data[index].freeze">（已被结算单锁定）</span>
                                <template v-else>
                                    <span v-if="data[index].settlemented" class="color-danger"> (已结款)</span>
                                    <span v-else> (未结款)</span>
                                </template>
                            </div>
                            <el-form-item :prop="`orderRefundDetailTOS[${index}].refundNum`"
                                :rules="[{ required: true, message: '请填写退款数量' }]" >
                                <!-- <span slot="label" v-if="data[index].settlemented">退款数量: <small>可退款数量 0</small></span> -->
                                <span slot="label">退款数量：</span>
                                <el-input-number style="width:100%" v-model="item.refundNum" :precision="0"
                                    controls-position="right" :min="0" :max="data[index].canRefundNum" size="medium"
                                    placeholder="请输入退款数量"
                                    :disabled="(data[index].canRefundNum == 0 || data[index].hasReviewed == 1) ? true : false">
                                </el-input-number>
								<small v-if="data[index].hasReviewed == 1" class="color-danger">存在审核中的售后申请，<el-link type="primary" :href="`/goodsManage/aftersales/list?queryType=1&queryValue=${data[index].orderSn}`" style="line-height: 25px;font-size: 12px;">点击查看详情</el-link></small>
								<template v-else>
									<span>可退款数量：<span class="color-danger">{{ data[index].canRefundNum }}</span></span>
									<el-link type="primary" v-if="data[index].hasAfterSale == 1" :href="`/goodsManage/aftersales/list?queryType=1&queryValue=${data[index].orderSn}`" style="line-height: 25px;font-size: 12px; margin-left: 10px;">点击查看详情</el-link>
								</template>								
                            </el-form-item>
                        </div>
                        <el-alert class="MT20" show-icon title="确认退款前请确保需退款商品已实际打款给用户" type="warning" :closable="false">
                        </el-alert>
                    </template>
						

                    <template v-if="formData.type == 2">
                        <div class="tips color-danger">"确定"将以下待退款商品调整为已退款</div>
                        <div v-for="(item, index) in formData.orderRefundDetailTOS" :key="index" class="tips">
                            <div class="goodsItem" v-if="!data[index].freeze && data[index].pendingRefundNum > 0">
                                {{ data[index].goodName }} <span class="color-info">{{ data[index].skuDesc }}</span>
                                <!-- <span> (未退款)</span> -->
                            </div>
                        </div>
                        <el-alert class="MT20" show-icon title="完成退款前请确保退款金额已打给用户" type="warning" :closable="false">
                        </el-alert>
                    </template>


                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="disabledType1 == true"
                    v-if="formData.type == 1">确定</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="disabledType2 == true"
                    v-if="formData.type == 2">确定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            id: '',
            data: null,
            formData: {
                type: 1,
                orderRefundDetailTOS: [],
                orderId: ''
            },
            disabledType2: false,
            disabledType1: false

        }
    },
    methods: {
        show(id) {
            this.id = id;
            this.getData();
            this.drawerShow = true;
        },
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.disabledType1 = false;
            this.disabledType2 = false;
        },
        // 获取数据
        getData() {

            this.dataLoading = true;
            this.$request({
                url: "/goodOrder/getRefundInfo",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = [...result];
                        this.formData = {
                            ...this.formData,
                            orderId: this.id,
                            orderRefundDetailTOS: this.data.map(v => {
                                return {
                                    refundNum: 0,
                                    orderDetailId: v.orderDetailId
                                }
                            })
                        }


                        const tagIds = this.data.filter(item => item.freeze === true).map(item => item.orderDetailId);//已冻结
                        const pendingRefundNums = this.data.filter(item => item.pendingRefundNum == 0).map(item => item.orderDetailId);//待退款数量
                        const canRefundNums = this.data.filter(item => item.canRefundNum == 0).map(item => item.orderDetailId);//可退款数量


                        if (tagIds.length == this.data.length || pendingRefundNums.length == this.data.length) {
                            this.disabledType2 = true
                        }
                        if (tagIds.length == this.data.length || canRefundNums.length == this.data.length) {
                            this.disabledType1 = true
                        }


                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //表单提交
        onSubmit() {

            //处理待退款的情况
            var orderRefundDetailTOS1 = [...this.formData.orderRefundDetailTOS];
            var dataType = [];

            if (this.formData.type == 1) {
                orderRefundDetailTOS1.forEach(item => {
                    if (item.refundNum != 0 && !item.freeze) {
                        dataType.push(item);
                    }
                })
            } else {
                var type2Data = [...this.data];
                type2Data.forEach(item => {
                    if (item.settlemented == false && item.pendingRefundNum > 0) {
                        dataType.push({ refundNum: 0, orderDetailId: item.orderDetailId });
                    }
                })
            }
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: "/goodOrder/refund",
                        method: "POST",
                        data: {
                            ...this.formData,
                            orderId: this.id,
                            orderRefundDetailTOS: dataType
                        },
                    })
                        .then((res) => {

                            //处理成功回调
                            const { state, msg, result } = res.data;
                            if (state && state == 1) {
                                if( result && result.type == 1 ){
                                    let _msg = '<div class="color-danger">以下商品已被结算单锁定，结算单付款前无法提交退款</div>';
                                    result.goodsName && result.goodsName.map(v => {
                                        _msg += '<div>'+v+'</div>';
                                    })
                                    this.$alert(_msg,'提交退款失败', {
                                        dangerouslyUseHTMLString: true
                                    })
                                }else if(result && (result.type == 0 || result.type == 2) ){
                                    const _type = result.type == 0 ? "对账失败" : "未对账"
                                    let _msg = `<div class="color-danger">该订单为“${_type}”${result.reason ? '，原因为：'+result.reason : ''}，在对账确认前无法提交退款</div>`;
                                    
                                    this.$alert(_msg,'提交退款失败', {
                                        dangerouslyUseHTMLString: true
                                    })
                                }else if(result && result.type == 3){
                                    let _msg = `<div class="color-danger">供应商未结款金额已经不足，不能为以下商品退款</div>`;
                                    result.goodsName && result.goodsName.map(v => {
                                        _msg += '<div>'+v+'</div>';
                                    })
                                    this.$alert(_msg,'提交退款失败', {
                                        dangerouslyUseHTMLString: true
                                    })   
                                }else{
                                    this.$emit('onUpdate');
                                    this.close();
                                }
                                
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.tips {
    margin-bottom: 20px;
}

.goodsItem {
    margin-bottom: 5px;
}
</style>